/* eslint-disable react/prop-types */
import React from 'react';

import { InfoItem } from '@molecules';
import { useMedia } from '@api/hooks';
import { getImage } from '@utils/media';

const BlockItem = ({ item, handleEdit }) => {
  const { media } = useMedia(getImage(item));

  return (
    <InfoItem image={media.src} onClick={handleEdit}>
      {item.title}
    </InfoItem>
  );
};

export default BlockItem;
